import { Hud } from '@sloyd/animation';
import { Unity, useUnity } from '@sloyd/viewer';
import { useEffect } from 'react';
import { Overlay, Wrapper } from './ContentHeroGenerator.style';
import config from './hud.json';

export type ContentHeroGeneratorProps = {
  animationState: IAnimationState;
  callbacks: {
    onCanvasReady: () => void;
  };
};

export function ContentHeroGenerator(props: ContentHeroGeneratorProps) {
  const { animationState, callbacks } = props;
  const { showHud } = animationState;
  const { unityProvider, isLoaded } = useUnity();

  useEffect(() => {
    if (!isLoaded) return;
    callbacks.onCanvasReady();
  }, [isLoaded]);

  function renderHud() {
    if (!showHud) {
      return null;
    }

    return <Hud json={config} />;
  }

  return (
    <Wrapper className='ContentHeroGenerator-wrapper' data-testid='ContentHeroGenerator-wrapper'>
      <Unity
        unityProvider={unityProvider}
        style={{
          height: window.innerHeight - 60,
          width: window.innerWidth - 200,
        }}
        matchWebGLToCanvasSize={true}
        devicePixelRatio={devicePixelRatio}
      />
      <Overlay>{renderHud()}</Overlay>
    </Wrapper>
  );
}

export default ContentHeroGenerator;
